import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './providers.styles'
import Profile from './provider/provider.container'
import FacebookIcon from 'react-icons/lib/fa/facebook'
import GoogleIcon from 'react-icons/lib/fa/google'
import TwitterIcon from 'react-icons/lib/fa/twitter'
import o365Icon from '../icons/o365'
import classNames from 'classnames'

const providersMap = {
  facebook: {
    icon: FacebookIcon,
    color: '#1a76f2',
    title: 'Facebook'
  },
  google: {
    icon: GoogleIcon,
    color: '#db4437',
    title: 'Google'
  },
  twitter: {
    icon: TwitterIcon,
    color: '#1da1f2',
    title: 'Twitter'
  },
  o365: {
    icon: o365Icon,
    color: '#dc3e15',
    title: 'Office 365'
  }
}

const Providers = ({ classes, providers, pending }) => (
  <Fragment>
    {!providers.length && <span>You haven't connected any providers</span>}
    {!!providers.length && (
      <ul
        className={classNames(classes.providers, {
          [classes.pending]: pending
        })}>
        {providers.map(provider => {
          const providerData = providersMap[provider.provider]
          return !providerData ? null : (
            <Profile
              id={provider.id}
              key={provider.id}
              Icon={providerData.icon}
              color={providerData.color}>
              {providerData.title}
            </Profile>
          )
        })}
      </ul>
    )}
  </Fragment>
)

export default injectSheet(styles)(Providers)
